import React, { useState } from 'react';
import { t } from 'i18n-js';
import { TCITooltip } from '@/components/ui/Tooltip';
import Card from '@/components/ui/Card';
import IReferenceMaterial from '@/components/interfaces/ReferenceMaterial';
import AssignButton from '@/components/shared/LessonOverview/Cards/AssignButton';
import Icon from '@/components/ui/Icon';
import { getNameFromTitle } from './utils';

interface ReferenceMaterialCardProps {
  currentStafferId?: number;
  programId: number;
  referenceMaterial: IReferenceMaterial;
  lessonId: number;
}

const ReferenceMaterialCard = ({
  currentStafferId, programId, referenceMaterial, lessonId,
}: ReferenceMaterialCardProps) => {
  const [isAssigned, setIsAssigned] = useState(false);
  const link = referenceMaterial.link.replace('program_id', programId.toString());
  const ariaLabel = `Navigate to ${getNameFromTitle(referenceMaterial.title)} reference page `
    + `${referenceMaterial.has_video ? `- ${t('contains_video')}` : ''}`;

  return (
    <Card className="tw-flex tw-flex-col tw-justify-between tw-min-w-0 tw-w-60">
      <Card.Image
        ariaHidden
        alt=""
        src={referenceMaterial.medium_image}
        tabIndex={-1}
        to={link}
        toText={`Navigate to reference page for ${referenceMaterial.title}`}
      />
      <Card.Body className="tw-h-full tw-min-h-0 tw-flex tw-flex-col tw-justify-between">
        <>
          <div className="tw-flex tw-justify-between">
            <div>
              <a aria-label={ariaLabel} className="tw-font-bold tw-text-base tw-bg-white" href={link}>
                {getNameFromTitle(referenceMaterial.title)}
              </a>
              <p className="tw-mt-2.5 tw-mb-0 tw-text-sm tw-text-gray-500 tw-bg-white">
                {referenceMaterial.date_range}
              </p>
            </div>
            {referenceMaterial.has_video && (
              <div aria-hidden="true" className="tw-justify-self-end" tabIndex={-1}>
                <TCITooltip>
                  <TCITooltip.Trigger asChild>
                    <span>
                      <Icon
                        aria-hidden="true"
                        className="tw-text-green"
                        icon="VideoActivity"
                        size={30}
                        tabIndex={-1}
                      />
                    </span>
                  </TCITooltip.Trigger>
                  <TCITooltip.Content>
                    {t('contains_video')}
                  </TCITooltip.Content>
                </TCITooltip>
              </div>
            )}
          </div>
          <div className="tw-mt-2">
            {currentStafferId && (
              <AssignButton
                className={`
                  tw-box-border tw-inline-flex tw-items-center tw-justify-center tw-w-7 tw-h-7 tw-text-[#777770]
                `}
                handlePostSave={() => setIsAssigned(true)}
                iconSize={16}
                initialValues={{
                  modelType: referenceMaterial.assignable_type,
                  modelsToAssign: referenceMaterial.model_to_assign,
                }}
                isAssigned={referenceMaterial.is_assigned || isAssigned}
                lessonId={lessonId}
                program={{ id: programId }}
                stafferId={currentStafferId}
              />
            )}
          </div>
        </>
      </Card.Body>
    </Card>
  );
};

export default ReferenceMaterialCard;
